function scrollnav() {
  var offsetValues = {
    small: 100,
    medium: 150,
    large: 170
  };

  var navLinks = Array.from(document.querySelectorAll('.scroll-nav a'));

  function applyOffset() {
    var offset = getOffsetValue();

    navLinks.forEach(function (link) {
      link.setAttribute('data-offset', offset);
    });
  }

  function getOffsetValue() {
    var screenWidth = window.innerWidth;

    if (screenWidth >= 1600) {
      return offsetValues.large;
    } else if (screenWidth >= 1200) {
      return offsetValues.medium;
    } else {
      return offsetValues.small;
    }
  }

  navLinks.forEach(function (link) {
    link.addEventListener('click', function (e) {
      e.preventDefault();

      navLinks.forEach(function (navLink) {
        navLink.classList.remove('current');
      });

      link.classList.add('current');

      var targetId = link.getAttribute('href').split('#')[1];
      var targetSection = document.getElementById(targetId);
      var offset = parseInt(link.getAttribute('data-offset'));

      if (!targetSection) {
        return; // Exit the function if target section is not found
      }

      var targetPosition = targetSection.getBoundingClientRect().top + window.pageYOffset - offset;

      window.scrollTo({
        top: targetPosition,
        behavior: 'smooth'
      });
    });
  });

  window.addEventListener('scroll', function () {
    var currentPosition = window.pageYOffset + getOffsetValue();

    var targetSections = Array.from(navLinks).map(function (link) {
      var targetId = link.getAttribute('href').split('#')[1];
      var targetSection = document.getElementById(targetId);
      return targetSection;
    });

    targetSections = targetSections.filter(function (section) {
      return section !== null;
    });

    if (targetSections.length === 0) {
      return;
    }

    var distances = targetSections.map(function (section) {
      return Math.abs(section.getBoundingClientRect().top + window.pageYOffset - getOffsetValue() - currentPosition);
    });

    var nearestIndex = distances.indexOf(Math.min(...distances));

    if (nearestIndex === -1) {
      return;
    }

    navLinks.forEach(function (link) {
      link.classList.remove('current');
    });

    // Check if navLinks[nearestIndex] is defined before accessing its classList
    if (navLinks[nearestIndex]) {
      navLinks[nearestIndex].classList.add('current');
    }
  });

  applyOffset();

  window.addEventListener('resize', function () {
    applyOffset();
  });
}

export default {
  init: function () {
    scrollnav();
  }
};
